import { render, staticRenderFns } from "./home1.vue?vue&type=template&id=87f335e0&"
import script from "./home1.vue?vue&type=script&lang=js&"
export * from "./home1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports